// removed by extract-text-webpack-plugin
module.exports = {"btn-create-role":"app-pages-Employees-Staff-EmptyState-__EmptyState___3DiKr","disabled":"app-pages-Employees-Staff-EmptyState-__EmptyState___xLDwX","popover":"app-pages-Employees-Staff-EmptyState-__EmptyState___15S2y"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Employees/Staff/EmptyState/EmptyState.css
// module id = 2333
// module chunks = 0